export const BROADCASTER_OPTIONS = [
  { id: '19571641', login: 'ninja', displayName: 'Ninja' },
  { id: '18074328', login: 'pokimane', displayName: 'Pokimane' },
  { id: '14333623', login: 'shroud', displayName: 'shroud' },
  { id: '71852806', login: 'lilypichu', displayName: 'LilyPichu' },
  { id: '121059319', login: 'kai_cenat', displayName: 'Kai Cenat' },
  { id: '11770174', login: 'xqc', displayName: 'xQc' },
];

export const CATEGORY_OPTIONS = [
  { id: '509658', name: 'Just Chatting', slug: 'just-chatting' },
  { id: '33214', name: 'Fortnite', slug: 'fortnite' },
  { id: '516575', name: 'VALORANT', slug: 'valorant' },
  { id: '21779', name: 'League of Legends', slug: 'league-of-legends' },
  { id: '27471', name: 'Minecraft', slug: 'minecraft' },
  { id: '511224', name: 'Apex Legends', slug: 'apex-legends' },
];

export const TRENDING_TAGS = [
  { id: 'esports', label: 'Esports' },
  { id: 'speedrun', label: 'Speedrun' },
  { id: 'irl', label: 'IRL' },
  { id: 'funny', label: 'Funny Moments' },
  { id: 'new-streamer', label: 'New Streamer' },
  { id: 'co-op', label: 'Co-op' },
];
